// extracted by mini-css-extract-plugin
export var dropdownButton = "_t-0";
export var fullWidthDropdownButton = "_t-1";
export var icon = "_t-3";
export var iconPlaceholder = "_t-2";
export var menuItemRow = "_t-9";
export var separator = "_t-e";
export var shortcutContainer = "_t-7";
export var shortcutContainerFilled = "_t-8";
export var shortcutIconLg = "_t-6";
export var shortcutIconMd = "_t-5";
export var shortcutIconSm = "_t-4";
export var submenuChevron = "_t-d";
export var submenuDropdown = "_t-a";
export var submenuTriggerRow = "_t-b";
export var submenuTriggerRowOpen = "_t-c";